/**
 * Deduplicates values that identify as BSON/Mongo ObjectIds (via `toHexString()`).
 * Later occurrences win for a given hex string, matching `Map`-based dedupe behavior.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "dedupeObjectIds", {
    enumerable: true,
    get: function() {
        return dedupeObjectIds;
    }
});
function dedupeObjectIds(ids) {
    return [
        ...new Map([
            ...ids
        ].map((id)=>[
                id.toHexString(),
                id
            ])).values()
    ];
}
